<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="选择公司" prop="companyId" >
        <a-select
          v-model="form.companyId"
          placeholder="请选择"
          @change="queryTemplateList"
          optionFilterProp="children"
          showSearch>
          <a-select-option v-for="(company,index) in companyList" :key="index" :value="company.id">{{ company.companyName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="选择模板" prop="templateId" >
        <a-select
          v-model="form.templateId"
          placeholder="请选择"
          optionFilterProp="children"
          showSearch>
          <a-select-option v-for="(template,index) in templateList" :key="index" :value="template.id">{{ template.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="打款任务名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="上传本地文件" prop="fileUrl" >
        <p style="margin-top: -40px;padding-left: 120px;font-size: 10px">
          为确保上传内容与列表内容匹配，请先
          <a @click="importTemplate">下载实例文件</a>
        </p>
        <a-spin tip="上传中..." :spinning="uploading">
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :file-list="fileList"
            :multiple="false"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <p class="ant-upload-hint">
              点击上传
            </p>
          </a-upload-dragger>
        </a-spin>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-textarea :row="4" v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space v-if="!form.id">
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import { getSalary, addSalary, updateSalary } from '@/api/user/salaryHead'
import { listCompany } from '@/api/user/company'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

const {listSalary} = require("@/api/user/salaryTemplate");
export default {
  name: 'CreateForm',
  props: {
  },
  components: {

  },
  data () {
    return {
      uploading: false,
      submitLoading: false,
      formTitle: '',
      fileList: [],
      companyList: [],
      templateList: [],
      fields: [],
      fieldIndex: null,
      // 表单参数
      form: {
        id: null,

        companyId: null,

        templateId: null,

        name: null,

        fileUrl: null,

        status: 0,

        cateName: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      name: '',
      rules: {
        companyId: [
          { required: true, message: '公司不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '打款任务名称不能为空', trigger: 'blur' }
        ]
        // fileUrl: [
        //   { required: true, message: '文件不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
    this.queryCompanyList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    changeFields() {
      this.$refs['fieldsForm'].openModal(this.form.id, this.fields[this.fields.length], this.fields.length)
    },
    addFields(field) {
      console.log('name========', field)
      this.fields.push(field)
    },
    editField(field, index) {
      this.fieldIndex = index
      this.$refs['fieldsForm'].openModal(this.form.id, field, index)
    },
    removeField(field, index) {
      this.fields.splice(index, 1)
    },
    queryCompanyList() {
      const param = {}
      listCompany(param).then(response => {
        this.companyList = response.data
      })
    },
    queryTemplateList() {
      const param = {
        companyId: this.form.companyId
      }
      listSalary(param).then(response => {
        this.templateList = response.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /** 下载模板操作 */
    importTemplate () {
      if (!this.form.companyId) {
        this.$message.warn('请先选择公司')
        this.confirmLoading = false
        return
      }
      if (!this.form.templateId) {
        this.$message.warn('请先选择模板')
        this.confirmLoading = false
        return
      }
      this.download('user/salary-head/importTemplate', {
        ...this.form
      }, `salary_template_${new Date().getTime()}.xlsx`)
    },
    /**
     * 文件上传前校验
     * @param {config.form.item} formItem 表单项
     * @param {*} fileInfo 文件详情, 见 a-upload 组件 customRequest 事件
     */
    beforeUpload(fileInfo) {
      // 图片类型字段, 进行文件类型判断
      // const fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      //
      // console.log(fileInfo.type)
      // if (!fileTypes.includes(fileInfo.type)) {
      //   this.$message.warning('请上传excel文件');
      //   return false;
      // }
      this.fileList = [fileInfo]
      console.log(this.fileList)
      return false
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.fileList = []
      this.form = {
        id: null,
        companyId: null,
        name: null,
        fields: null,
        status: 0,
        cateName: null,
        createTime: null,
        remark: null
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSalary({ 'id': id }).then(response => {
        this.form = response.data

        this.open = true
        this.formTitle = '查看'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const { fileList } = this
          const formData = new FormData()
          formData.append('file', fileList[0])
          formData.append('companyId', this.form.companyId)
          formData.append('name', this.form.name)
          formData.append('remark', this.form.remark)
          if (this.form.id !== undefined && this.form.id !== null) {
            formData.append('id', this.form.id)
            updateSalary(formData).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSalary(formData).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  thead {
    tr {
      th {
        padding: 6px 8px;
        color: #000;
        font-weight: 500;
        text-align: left;
        background: #fafafa;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease
      }
    }
  }

  tbody {
    tr {
td {
  padding: 12px 8px;
  color: #000;
  text-align: left;
  background: #fff;
  border: 1px solid #e8e8e8;
  transition: background 0.3s ease;
  word-break: break-word;
  line-height: 18px;
}
}
}
}
</style>
